import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { WebStorageService } from './web-storage.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ResultOfT } from '../models/response/result';
import { PaymentInformationModel } from 'src/app/interfaces/payment-information';
import { PaymentSetupRequestModel } from 'src/app/interfaces/payment-integration';
import { PaymentHistory } from 'src/app/interfaces/payment-history';
import { UpdatePaymentAmountRequest } from 'src/app/interfaces/update-payment-amount-request copy';
import { PaymentSetupModel } from 'src/app/interfaces/payment-setup';
import { PaymentResponseModel } from 'src/app/interfaces/payment-response';
import { PaymentTransactionReportModel, PaymentTransactionRequestModel } from 'src/app/interfaces/payment-transaction';
import { PagedResponseModel } from '../models/response/paged-response-model';

@Injectable({
  providedIn: 'root'
})
export class PaymentService extends BaseService {
  ctrl = 'payment';

  paymentCompleted$: Subject<PaymentResponseModel> = new Subject<PaymentResponseModel>();
  paymentCompletedPatient$: BehaviorSubject<PaymentResponseModel> = new BehaviorSubject<PaymentResponseModel>(null);

  constructor(httpService: HttpClient, webStorageService: WebStorageService) {
    super(httpService, webStorageService);
  }

  createPaymentSetup(request: PaymentSetupRequestModel) {
    return this.post<ResultOfT<PaymentSetupModel>>(`${this.ctrl}/setup`, request);
  }

  clearPaymentSetup(request: PaymentSetupModel) {
    return this.post<ResultOfT<PaymentSetupModel>>(`${this.ctrl}/setup/clear`, request);
  }

  chargeAndBook(request: PaymentSetupRequestModel): Observable<ResultOfT<PaymentResponseModel>> {
    return this.post<ResultOfT<PaymentResponseModel>>(`${this.ctrl}/charge`, request);
  }

  timeoutPaymentSetup(request: PaymentSetupModel) {
    return this.post<ResultOfT<PaymentResponseModel>>(`${this.ctrl}/setup/timeout`, request);
  }

  chargeCancellation(request: PaymentSetupRequestModel): Observable<ResultOfT<PaymentResponseModel>> {
    return this.post<ResultOfT<PaymentResponseModel>>(`${this.ctrl}/charge-cancellation`, request);
  }

  getPaymentInformation(salesorderId: number): Observable<ResultOfT<PaymentInformationModel>> {
    return this.get<ResultOfT<PaymentInformationModel>>(`${this.ctrl}/information/${salesorderId}`);
  }

  deleteCard(id: number): Observable<ResultOfT<boolean>> {
    return this.delete<ResultOfT<boolean>>(`${this.ctrl}/card/${id}`);
  }

  updatePaymentAmount(request: UpdatePaymentAmountRequest): Observable<ResultOfT<boolean>> {
    return this.post<ResultOfT<boolean>>(`${this.ctrl}/update-amount`, request);
  }

  getPaymentHistory(salesorderId: number): Observable<ResultOfT<PaymentHistory[]>> {
    return this.get<ResultOfT<PaymentHistory[]>>(`${this.ctrl}/history/${salesorderId}`);
  }

  getPaymentTransactionLogs(request: PaymentTransactionRequestModel) {
    return this.post<ResultOfT<PagedResponseModel<PaymentTransactionReportModel>>>(`${this.ctrl}/transaction-logs`, request);
  }

  exportPaymentTransactionLogs(request: PaymentTransactionRequestModel) {
    return this.downloadCsvFile(`${this.ctrl}/transaction-logs/export`, request);
  }
}
